import { Outlet } from 'react-router'
import { OrgAccessStatus, useOrgAccess } from 'shared-ui/active-operation'
import { Forbidden403, Loading } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'

export const RequireOrgAccessGuard: React.FC = () => {
  const access = useOrgAccess()
  const { t } = useLocalization()

  if (access.status === OrgAccessStatus.Pending) {
    return <Loading />
  }

  if (access.status === OrgAccessStatus.Denied) {
    return (
      <div className="mx-12 my-20 md:mx-48">
        <Forbidden403 message={t(($) => $.messages.noOperationAccess)} />
      </div>
    )
  }

  return <Outlet />
}
